import { Controller } from "@hotwired/stimulus";

// New-interaction form: one screen where the date decides the mode.
// A past (or now) date means logging something that happened; a future date
// means planning something — the notes copy and submit label follow along.
export default class extends Controller {
  static targets = ["dateInput", "notesLabel", "notesHelp", "notesInput", "submitButton"];

  connect() {
    this.render();
  }

  render() {
    const future = this.isFuture();

    if (this.hasNotesLabelTarget) {
      this.notesLabelTarget.textContent = future ? "What's the agenda?" : "What happened?";
    }
    if (this.hasNotesHelpTarget) {
      this.notesHelpTarget.textContent = future
        ? "Topics, agenda, or context for this plan."
        : "Key takeaways, decisions, or action items from the conversation.";
    }
    if (this.hasNotesInputTarget) {
      this.notesInputTarget.placeholder = future
        ? "Topics or agenda…"
        : "Notes from the conversation…";
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.value = future ? "Add to timeline" : "Log conversation";
    }
  }

  isFuture() {
    if (!this.hasDateInputTarget || !this.dateInputTarget.value) return false;
    const date = new Date(this.dateInputTarget.value);
    return !isNaN(date) && date > new Date();
  }
}
